import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { managedCompaniesSelector } from '../Settings/store/SettingsSelectors'
import Announcements, { IAnnouncementsDispatchProps, IAnnouncementsProps } from './Announcements'
import { deleteAnnouncements, getAnnouncementFilters, getAnnouncements } from './store/AnnouncementsActions'
import {
  getAnnouncementsFilters,
  getAnnouncementsLastUpdate,
  getAnnouncementsList,
  getAnnouncementsLoading,
} from './store/AnnouncementsSelectors'
import { getCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminSelectors'
import { setCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminActions'

const mapStateToProps = (state: IGlobalState): IAnnouncementsProps => ({
  selectedCompanyId: getCompanyAdminSelectedCompanyId(state),
  managedCompanies: managedCompaniesSelector(state),
  announcements: getAnnouncementsList(state),
  isLoading: getAnnouncementsLoading(state),
  lastUpdate: getAnnouncementsLastUpdate(state),
  filters: getAnnouncementsFilters(state),
})

const mapDispatchToProps: IAnnouncementsDispatchProps = {
  setSelectedCompanyId: setCompanyAdminSelectedCompanyId,
  getAnnouncements,
  deleteAnnouncements,
  getAnnouncementFilters,
}

export default connect(mapStateToProps, mapDispatchToProps)(Announcements)
